/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * jelled services
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from 'react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  NotificationSettings,
  NotificationsListSettingsParams,
  NotificationSubscription,
  NotificationsUpdateSettingsParams
} from '../notifications'

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


/**
 * List notification settings by the subscription id
 * @summary List notification settings by the subscription id
 */
export const notificationsListSettings = (
    params: NotificationsListSettingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    return axios.get(
      `/api/notification-settings`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getNotificationsListSettingsQueryKey = (params: NotificationsListSettingsParams,) => [`/api/notification-settings`, ...(params ? [params]: [])];

    
export type NotificationsListSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsListSettings>>>
export type NotificationsListSettingsQueryError = AxiosError<unknown>

export const useNotificationsListSettings = <TData = Awaited<ReturnType<typeof notificationsListSettings>>, TError = AxiosError<unknown>>(
 params: NotificationsListSettingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationsListSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsListSettingsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsListSettings>>> = ({ signal }) => notificationsListSettings(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof notificationsListSettings>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update notification setting by name
 * @summary Update notification setting by name
 */
export const notificationsUpdateSettings = (
    notificationSubscription: NotificationSubscription[],
    params: NotificationsUpdateSettingsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/notification-settings`,
      notificationSubscription,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type NotificationsUpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsUpdateSettings>>>
    export type NotificationsUpdateSettingsMutationBody = NotificationSubscription[]
    export type NotificationsUpdateSettingsMutationError = AxiosError<unknown>

    export const useNotificationsUpdateSettings = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsUpdateSettings>>, TError,{data: NotificationSubscription[];params: NotificationsUpdateSettingsParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsUpdateSettings>>, {data: NotificationSubscription[];params: NotificationsUpdateSettingsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  notificationsUpdateSettings(data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof notificationsUpdateSettings>>, TError, {data: NotificationSubscription[];params: NotificationsUpdateSettingsParams}, TContext>(mutationFn, mutationOptions)
    }
    
